/**
 * Which support URL prefix the current page is mounted under.
 *
 * The same three pages (MyTickets, CreateTicket, TicketDetail) serve buyers,
 * sellers and delivery agents — they already branch on which auth is active to
 * pick their category list. Only the shell differs: a seller belongs inside
 * SellerLayout's sidebar, an agent inside DeliveryLayout, a buyer inside the
 * 480px UserRouteWrapper frame.
 *
 * They used to hardcode '/support/...' for every internal link, so a seller who
 * opened Support was dropped into the buyer shell — buyer bottom nav, mobile
 * frame, no sidebar — and every link kept them there.
 *
 * Deriving the prefix from the current path rather than from auth keeps the
 * pages shell-agnostic: mount them anywhere and their navigation stays put.
 */
export const supportBase = (pathname = '') => {
  if (pathname.startsWith('/seller/support')) return '/seller/support';
  if (pathname.startsWith('/delivery/support')) return '/delivery/support';
  return '/support';
};

/** Where to send someone who leaves support entirely. */
export const supportHome = (pathname = '') => {
  if (pathname.startsWith('/seller/support')) return '/seller/dashboard';
  if (pathname.startsWith('/delivery/support')) return '/delivery/dashboard';
  return '/';
};
